"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsGeneral = void 0;
const button_1 = require("client/components/material/button");
const switch_1 = require("client/components/material/switch");
const text_field_1 = require("client/components/material/text-field");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const app_settings_1 = require("shared/app-settings");
const store_1 = require("../../store");
require("./app-settings-general.less");
let AppSettingsGeneral = class AppSettingsGeneral extends React.Component {
    constructor() {
        super(...arguments);
        this.settings = null;
        this.didChange = false;
        this.originalSettings = null;
        this.handleUpdateValue = (i) => (e, v) => {
            this.settings[i].value = v;
            if (this.settings[i].name === app_settings_1.AppOption.EobPayPeriods && v > 48) {
                this.settings[i].value = "48";
            }
            this.checkChange();
        };
        this.handleSubmit = async () => {
            const result = await store_1.appSettingsStore.updateSettings(this.settings);
            this.didChange = false;
        };
    }
    async componentDidMount() {
        const settings = await store_1.appSettingsStore.readSettings();
        const cleaned = settings
            .filter((setting) => !setting.devOnly &&
            setting.category !== app_settings_1.AppCategory.rejections &&
            setting.category !== app_settings_1.AppCategory.assets &&
            setting.category !== app_settings_1.AppCategory.billing)
            .sort((a, b) => a.category > b.category ? 1 : -1)
            .map((e) => e);
        this.settings = cleaned;
        this.originalSettings = cleaned;
    }
    async componentWillUnmount() {
        this.settings = null;
        this.originalSettings = null;
    }
    checkChange() {
        const cleanObj = this.settings.map((e) => e);
        const isDiff = ramda_1.difference(Object.entries(cleanObj), Object.entries(this.originalSettings));
        this.didChange = isDiff.length > 0;
    }
    renderSettings() {
        const settings = this.settings;
        const groups = [];
        const blocks = [];
        let count = 0;
        settings.forEach((setting) => {
            const groupName = setting.category;
            if (!groups.includes(groupName))
                groups.push(groupName);
        });
        groups.forEach((group) => {
            blocks.push(React.createElement("div", { className: "settings__block" },
                React.createElement("h3", { className: "settings__block-title", id: group }, group.toUpperCase()),
                React.createElement("div", { className: "settings__block-entries" }, settings
                    .filter((setting) => setting.category === group)
                    .map((e) => {
                    const i = count;
                    const name = e.displayName;
                    const desc = e.description;
                    const value = e.value;
                    const type = e.settingType;
                    let display;
                    if (type === app_settings_1.AppType.string) {
                        display = (React.createElement(text_field_1.MaterialTextField, { onChange: this.handleUpdateValue(i), type: "text", label: name, value: value }));
                    }
                    if (type === app_settings_1.AppType.boolean) {
                        display = (React.createElement(switch_1.MaterialSwitch, { onChange: this.handleUpdateValue(i), label: name, checked: value === "1" || value === true }));
                    }
                    if (type === app_settings_1.AppType.number) {
                        display = (React.createElement(text_field_1.MaterialTextField, { onChange: this.handleUpdateValue(i), type: "number", label: name, value: value }));
                    }
                    count++;
                    return (React.createElement("div", { className: "settings__block-entry" },
                        React.createElement("div", { className: "settings__block-entry--title" }, name),
                        React.createElement("div", { className: "settings__block-entry--body" },
                            React.createElement("span", { className: "settings__block-entry--body-desc" }, desc),
                            React.createElement("span", { className: "settings__block-entry--body-disp" }, display))));
                }))));
        });
        const wrapper = (React.createElement("div", { className: "settings__wrapper" },
            React.createElement("div", { className: "settings__block" }, blocks.map((e) => e)),
            React.createElement("div", { className: "settings__submit" },
                React.createElement(button_1.MaterialButton, { primary: true, className: "settings__submit--button", disabled: !this.didChange, onClick: this.handleSubmit }, "Save"))));
        return wrapper;
    }
    render() {
        const didLoad = !!this.settings;
        return (React.createElement("div", null, didLoad ? this.renderSettings() : React.createElement("p", null, "Component is loading.")));
    }
};
__decorate([
    mobx_1.observable
], AppSettingsGeneral.prototype, "settings", void 0);
__decorate([
    mobx_1.observable
], AppSettingsGeneral.prototype, "didChange", void 0);
AppSettingsGeneral = __decorate([
    mobx_react_1.observer
], AppSettingsGeneral);
exports.AppSettingsGeneral = AppSettingsGeneral;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-general/app-settings-general.tsx
// module id = 3191
// module chunks = 0